import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`v1/api/notification/logs?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`v1/api/notification/logs/${id}`, { params });
}

export async function create(body) {
  return request(`v1/api/notification/sms`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/notification/sms`, {
    method: 'POST',
    body,
  });
}

export async function createEmail(body) {
  return request(`v1/api/notification/email`, {
    method: 'POST',
    body,
  });
}

export async function updateEmail(id, body) {
  return request(`v1/api/notification/email`, {
    method: 'POST',
    body,
  });
}